import { render, staticRenderFns } from "./assembly.vue?vue&type=template&id=442e8ec6&scoped=true&"
import script from "./assembly.vue?vue&type=script&lang=js&"
export * from "./assembly.vue?vue&type=script&lang=js&"
import style0 from "./assembly.vue?vue&type=style&index=0&id=442e8ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e8ec6",
  null
  
)

export default component.exports